import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { BuscaGlobal } from "./BuscaGlobal";

/** A lupa da barra superior. Ctrl+K (⌘K no Mac) abre de qualquer tela. */
export function BotaoBusca() {
  const [aberta, setAberta] = useState(false);

  useEffect(() => {
    const atalho = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setAberta((v) => !v);
      }
    };
    window.addEventListener("keydown", atalho);
    return () => window.removeEventListener("keydown", atalho);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setAberta(true)}
        aria-label="Buscar na plataforma"
        title="Buscar (Ctrl+K)"
        className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      >
        <Search className="h-5 w-5" />
      </button>
      <BuscaGlobal open={aberta} onClose={() => setAberta(false)} />
    </>
  );
}
